<header class="header">
  <div class="title">
    <kin-icon name="gps_stroke" [color]="colorService.textColor() || 'white'" />
    <h3>{{ 'gps_uploader.title' | translate }}</h3>
  </div>
  @if (mediaBlockService.gpsFileData()) {
    <p>
      <span>{{ 'common.file.name' | translate }}</span>
      {{ mediaBlockService.gpsFileData()!.name }}
      <span>{{ 'common.file.duration' | translate }}</span>
      {{ mediaBlockService.gpsFileData()!.duration | formatDuration }}
      <span>{{ 'common.file.weight' | translate }}</span>
      {{ mediaBlockService.gpsFileData()!.weight | fileSize }}
    </p>
  } @else {
    <p>{{ 'gps_uploader.import_hint' | translate }}</p>
  }
</header>

<div class="data-control">
  @if (isLoadingTrack()) {
    <div class="loader-track">
      <kin-pulse-loader [color]="loaderColor" />
      <span>{{ 'gps_uploader.parsing' | translate }}</span>
    </div>
  } @else if (!mediaBlockService.gpsFile()) {
    <div class="field-group">
      <label
        for="gps"
        class="gps-label"
        #gpsDropzone
        (drop)="onGpxDrop($event)"
        (dragover)="setIsGpxDragOver($event, true)"
        (dragleave)="setIsGpxDragOver($event, false)"
        [class.error]="
          mediaForm().get('coordinates')?.invalid && mediaForm().get('coordinates')?.touched
        "
      >
        <header>
          <kin-icon name="upload" color="#428FF3" />
          <h5>{{ 'gps_uploader.upload_title' | translate }}<span class="requied">*</span></h5>
          <p>{{ 'gps_uploader.upload_hint' | translate }}</p>
        </header>
        <footer>
          <span class="files-type-required-label">{{ 'common.file.format' | translate }}</span>
          <span class="files-type-required-list">
            @for (gpsSupport of gpsFilesSupport; track $index; let last = $last) {
              @if (last) {
                {{ 'common.and' | translate }}
              }
              .{{ gpsSupport | uppercase }}
            }
          </span>
        </footer>
      </label>
      @if (mediaForm().get('coordinates')?.invalid && mediaForm().get('coordinates')?.touched) {
        <p class="field-error">{{ 'common.required_field' | translate }}</p>
      }
    </div>
  } @else if (controlsStarted() && (!controlsDone() || controlsHaveError())) {
    <div class="gps-label">
      <header>
        @if (controlsHaveError()) {
          <kin-icon name="close" [color]="colorService.danger500()" />
          <p [style.color]="colorService.danger500()">{{ 'gps_uploader.invalid' | translate }}</p>
        } @else {
          <kin-wheel-loader [size]="24" />
          <p>{{ 'gps_uploader.analysing' | translate }}</p>
        }
      </header>
      <div class="controls">
        <app-gps-upload-control-item
          [text]="controlGpsCompatibility().text"
          [status]="controlGpsCompatibility().status"
          [validate]="controlGpsCompatibility().validate"
        />
        <app-gps-upload-control-item
          [text]="controlGpsDuration().text"
          [status]="controlGpsDuration().status"
          [validate]="controlGpsDuration().validate"
        />
        <app-gps-upload-control-item
          [text]="controlGpsSpeed().text"
          [status]="controlGpsSpeed().status"
          [validate]="controlGpsSpeed().validate"
        />
        <app-gps-upload-control-item
          [text]="controlGpsData().text"
          [status]="controlGpsData().status"
          [validate]="controlGpsData().validate"
        />
      </div>
      <button (click)="onRemoveGPS()" class="remove-file-btn">
        <kin-icon name="trash" color="#EA302D" />
        <p>{{ 'common.delete' | translate | titlecase }}</p>
      </button>
    </div>
  } @else {
    <div class="map-container">
      @if (isBrowser && rawCoordinates().length) {
        <app-map />
        <footer>
          <button (click)="onRemoveGPS()" class="remove-file-btn">
            <kin-icon name="trash" color="#EA302D" />
            <p>{{ 'common.delete' | translate | titlecase }}</p>
          </button>
          @if (autoSyncService.syncMode() === 'auto') {
            <div class="message dark">
              <p>
                <span class="strong">{{ 'gps_uploader.sync.auto_title' | translate }}</span>
                {{ 'gps_uploader.sync.auto_hint' | translate }}
              </p>
            </div>
          } @else if (autoSyncService.syncMode() === 'manual') {
            <div class="message light">
              <p>
                <span class="strong">{{ 'gps_uploader.sync.manual_title' | translate }}</span>
                {{ 'gps_uploader.sync.manual_hint' | translate }}
              </p>
              <button class="cta-black stroke" (click)="autoSyncService.setAutoMode()">
                {{ 'gps_uploader.sync.reactivate' | translate }}
              </button>
            </div>
          }
        </footer>
      }
    </div>
  }
  <input
    type="file"
    name="gps"
    id="gps"
    [multiple]="false"
    (change)="onSelectGpxFile($event)"
    [accept]="gpsAccept"
    #gpsInput
  />
</div>
